import ListWidgetMixin from "../mixins/ListWidgetMixin";

Vue.asyncComponent('ak-data-chips', {
    mixins: [ListWidgetMixin],
    props: {
        items: {
            type: Array,
            required: false,
        },
        itemsPerRow: {
            type: Number|String,
            required: false,
        },
    }
}, 'layout/ak-data-chips.html');